var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { AiringType, Channel } from "core/codegen/types";
import { ChannelLogo } from "core/components/ChannelLogo";
import { SingularAirtime } from "core/components/SingularAirtime";
import { colors, fontWeight, mq } from "core/styles/snippets";
import { Id, content, date } from "core/utils";
import React from "react";
import ReactMarkdown from "react-markdown";
import styled, { css } from "styled-components";
var renderContainer = function (airingInfo, channel, isColor, className) {
    return (React.createElement(Container, { className: className },
        React.createElement(AiringText, { isColor: isColor }, airingInfo),
        React.createElement(ChannelLogoStyled, { channel: channel, "data-component": Id.component.logo[channel], isColor: isColor })));
};
export var Airing = function (_a) {
    var airing = _a.airing, broadcast = _a.broadcast, channel = _a.channel, isColor = _a.isColor, isOrange = _a.isOrange, className = _a.className, _b = _a.isMovie, isMovie = _b === void 0 ? false : _b, _c = _a.disablePulsar, disablePulsar = _c === void 0 ? false : _c, hasAppendedLogo = _a.hasAppendedLogo;
    if (channel === Channel.Vtmgoexclusives) {
        return renderContainer("exclusief op", channel, isColor, className);
    }
    // Show airing info when provided
    if (airing.info) {
        return renderContainer(airing.info, channel, isColor, className);
    }
    // IF broadcast = unavailable AND airing type = archived
    // Return null
    if (!broadcast && airing.type !== AiringType.ComingSoon) {
        return null;
    }
    // IF broadcast = unavailable
    // Return: `Binnenkort bij ${channelLogo}`
    if (!broadcast) {
        var info = hasAppendedLogo
            ? content.programsPage.comingSoonWithAppendedLogo
            : content.programsPage.comingSoon;
        return renderContainer(info, channel, isColor, className);
    }
    // IF broadcast = available && broadcast < 7 dagen
    // OR program is already on air
    // Return `${weekdag} ${uur} ${channelLogo}`
    if (date.isWithinDays(broadcast.start, 7)) {
        return (React.createElement(SingularAirtime, { start: broadcast.start, end: broadcast.end, channel: channel, isColor: isColor, isOrange: isOrange, className: className, disablePulsar: disablePulsar }));
    }
    // IF movie and broadcast > 7 dagen
    // Return `${datum} ${channelLogo}`
    if (isMovie) {
        return renderContainer("".concat(content.movieDateOn(date.getDayMonth(broadcast.start)).label), channel, isColor, className);
    }
    // IF broadcast > 7 dagen but already on air
    // Return `${weekdag} ${uur} ${channelLogo}`
    if (airing.type === AiringType.OnAir) {
        return (React.createElement(SingularAirtime, { start: broadcast.start, end: broadcast.end, channel: channel, isColor: isColor, isOrange: isOrange, className: className, disablePulsar: disablePulsar }));
    }
    // ELSE
    // Return: `Vanaf ${datum} bij ${channelLogo}`
    return renderContainer("".concat(content.fromDateOn(date.getDayMonth(broadcast.start)).label), channel, isColor, className);
};
export var ChannelLogoStyled = styled(ChannelLogo)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 0.3rem;\n  height: 0.9rem;\n  margin-right: 1rem;\n"], ["\n  margin-left: 0.3rem;\n  height: 0.9rem;\n  margin-right: 1rem;\n"])));
export var AiringText = styled(ReactMarkdown)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-size: 1rem;\n  font-weight: 400;\n\n  p {\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n\n    ", "\n  }\n"], ["\n  text-transform: uppercase;\n  font-size: 1rem;\n  font-weight: 400;\n\n  p {\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n\n    ", "\n  }\n"])), function (props) {
    return props.isColor && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), colors.black);
});
export var Container = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.875rem;\n  ", ";\n  display: flex;\n  flex-flow: row;\n\n  ", " {\n    font-size: 1rem;\n  }\n\n  ", " {\n    font-size: 1.125rem;\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  font-size: 0.875rem;\n  ", ";\n  display: flex;\n  flex-flow: row;\n\n  ", " {\n    font-size: 1rem;\n  }\n\n  ", " {\n    font-size: 1.125rem;\n  }\n\n  ", "\n"])), colors.white, fontWeight.light, mq.minWidth("64rem"), mq.minWidth("90rem"), function (props) {
    return props.isColor && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), colors.black);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
